import { render } from "./Employees.vue?vue&type=template&id=a222f1f0&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=a222f1f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a222f1f0"]])

export default __exports__